module.exports = __webpack_public_path__ + "static/media/whatsapp-button.b798b065.png";